import $ from 'jquery';

const MobileMenuChildren = (el) => {
    let $el = $(el);
    $el.click(function (e) {
        e.preventDefault();

        var children_menu = $(this).next();
        $(children_menu).slideToggle('200');

        $(this).toggleClass('active');
    });
};

export default MobileMenuChildren;
